module.exports = "<a   style=\"font-size: 11px; color: darkblue;\"><i class=\"icon wb-pencil\"></i>  </a>                    "